import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Button from "../../lib/Button";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class HandDevicePopup extends Popup
{
    // #region Attributes //

    // private:

    private _playerIndex: number = null;

    // #endregion //


    public set playerIndex( value: number) { this._playerIndex = value; }


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();  

        console.assert( this._playerIndex !== null, "HandDevicePopup.ts :: onEnter() :: this._playerIndex cannot be null." );

        let messageTop: PIXI.Text = new PIXI.Text( "Hand device to", {
            fontSize: 60,
            fontFamily: "jaro_regular", 
            fill: 0xffffff
        } );
        messageTop.anchor.set( 0.5, 0 );
        messageTop.position.set( ServiceLocator.app.width * 0.5, 200 );
        this._root.addChild( messageTop );   
        //
        let messageBottom: PIXI.Text = new PIXI.Text( "PLAYER " + ( this._playerIndex == 0 ? "1" : "2" ), {
            fontSize: 90,
            fontFamily: "jaro_regular", 
            fill: 0xffffff
        } );
        messageBottom.anchor.set( 0.5, 0 );
        messageBottom.position.set( messageTop.x, messageTop.y + messageTop.height );
        this._root.addChild( messageBottom );   

        let logo: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.hand_device_logo.texture );
        logo.anchor.set( 0.5 );
        logo.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( logo );

        let readyBtn: Button = new Button( { on: "button_ready", pressed: "button_ready_pressed" } );
        readyBtn.anchor.set( 0.5 );
        readyBtn.position.set( ServiceLocator.app.width * 0.5, logo.y + logo.height * 0.5 + 160 );
        this._root.addChild( readyBtn );
        readyBtn.on( "pointertap", this._onReadyBtn_Click.bind( this ) );
    }

        private _onReadyBtn_Click(): void
        {
            this._onClosed.dispatch();
        }

    // #endregion //
}